module.exports = __webpack_public_path__ + "static/media/teach.7eea0c46.jpg";